/**
 * The region to send the requests to.
 *
 * @public
 */
export enum Region {
  US = "US",
  EU = "EU",
}
